import { set } from 'lodash'

export const updatePending = (
  dotPath
) => (
  target,
  value
) => set(target, dotPath, value)